import type { NextPage } from "next";
import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  isGradient?: boolean;
  gradientId?: string;
  from?: string;
  to?: string;
}

const ExecutiveLoungeIcon: NextPage<Props> = ({
  fill = "currentColor",
  from,
  to,
  gradientId = "ExecutiveLoungeIconGradient",
  isGradient = false,
  ...props
}) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      {isGradient && (
        <defs>
          <linearGradient id={gradientId}>
            <stop offset="0%" stopColor={from} />
            <stop offset="100%" stopColor={to} />
          </linearGradient>
        </defs>
      )}
      <path
        d="M22.091 11.4129V9.87525C22.091 9.62391 21.8866 9.41949 21.6352 9.41949H19.3238V9.01958C19.7147 8.76992 20.2372 7.46574 20.261 7.33002C20.3085 7.19932 20.285 7.04796 20.1984 6.92508C20.1118 6.8022 19.9747 6.72904 19.8317 6.72904H17.909C17.7657 6.72234 17.6333 6.79495 17.544 6.91615C17.4529 7.03903 17.4275 7.18927 17.4714 7.31662C17.5027 7.51434 18.0603 8.80176 18.4122 9.02182V9.41949H14.0582V7.95334C14.0582 7.702 13.8538 7.49758 13.6024 7.49758H4.6472C4.39586 7.49758 4.19144 7.702 4.19144 7.95334V10.9566H2.72557C2.47423 10.9566 2.26953 11.1615 2.26953 11.4129V18.7151C2.26953 18.9665 2.47423 19.1709 2.72557 19.1709H21.6352C21.7556 19.1709 21.8732 19.1223 21.9572 19.0374C22.0424 18.9531 22.091 18.8358 22.091 18.7151C22.091 18.4454 22.0382 18.1845 21.9346 17.9399C21.638 17.2199 20.8932 16.7217 20.1188 16.7217H18C18.334 16.0744 18.4954 15.2992 18.5072 14.2949C18.4954 13.2845 18.3382 12.5294 17.9995 11.8687H21.6352C21.8866 11.8687 22.091 11.6642 22.091 11.4129ZM4.95998 11.8686V18.2594H3.18134V11.8686H4.95998ZM18.5745 7.64056H19.1618C19.0584 7.86956 18.9526 8.06337 18.868 8.18122C18.7834 8.06337 18.6778 7.869 18.5745 7.64056ZM21.1795 10.331V10.9571H12.4055V10.331H21.1795ZM15.0781 14.296C15.0895 15.3064 15.2465 16.061 15.5855 16.7217H13.4871C13.4223 16.7217 13.3564 16.7251 13.2897 16.7318V11.8686H15.5849C15.2509 12.516 15.0895 13.2912 15.0781 14.296ZM12.5066 18.2594C12.6822 17.8818 13.0646 17.6344 13.4871 17.6338H20.0979C20.5204 17.6344 20.9027 17.8818 21.0784 18.2594H12.5066ZM12.3778 16.4804V17.0596C12.27 17.1317 12.1692 17.2144 12.0779 17.3054C11.816 17.5662 11.633 17.8952 11.5465 18.2594H5.87179V16.4804H12.3778ZM5.41602 10.9571H5.10296V8.40967H13.1467V9.4195H11.9497C11.6984 9.4195 11.494 9.62392 11.494 9.87526V11.4129C11.494 11.6642 11.6984 11.8687 11.9497 11.8687H12.3778V12.8785H5.87178V11.4129C5.87178 11.1616 5.66736 10.9571 5.41602 10.9571ZM5.87178 15.5689V13.79H12.3778V15.5689H5.87178ZM16.7925 16.7217C16.5093 16.7217 15.9896 15.8007 15.9896 14.2955C15.9896 12.7902 16.5093 11.8687 16.7925 11.8687C17.0757 11.8687 17.5954 12.7902 17.5954 14.2955C17.5954 15.8007 17.0757 16.7217 16.7925 16.7217Z"
        fill={isGradient ? `url(#${gradientId})` : fill}
      />
    </svg>
  );
};

export default ExecutiveLoungeIcon;
